import redact from "./_redact";

const sendExternalEvent = (url) => {
  // eslint-disable-next-line no-undef
  dataLayer.push({
    GAEventBridgeAction: redact(document.location.href),
    GAEventBridgeCategory: "Outbound Links",
    GAEventBridgeLabel: redact(url.href),
  });
  // eslint-disable-next-line no-undef
  dataLayer.push({ event: "GAEventBridge", "gtm.uniqueEventId": 1 });
};

export default sendExternalEvent;
